// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".success-step-body[data-v-5a9beb62]{color:#858f9b;font-family:Inter;font-size:14px;font-weight:400}.success-step-icon[data-v-5a9beb62]{padding-bottom:24px}.success-step-text[data-v-5a9beb62]{padding-bottom:52px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
